import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function CalendarCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const code = searchParams.get('code');
    const error = searchParams.get('error');

    if (error) {
      // Send error to parent window
      if (window.opener) {
        window.opener.postMessage({ type: 'oauth-callback', error }, '*');
        window.close();
      } else {
        navigate('/calendar-settings');
      }
      return;
    }

    if (code) {
      // Send code to parent window
      if (window.opener) {
        window.opener.postMessage({ type: 'oauth-callback', code }, '*');
        window.close();
      } else {
        // If not in popup, redirect to settings
        navigate('/calendar-settings');
      }
    }
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0a0f1a]">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-yellow-500 mx-auto"></div>
        <p className="mt-4 text-slate-300 font-medium">Processing calendar connection...</p>
      </div>
    </div>
  );
}
